module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/back-a6be88d3a8faa1cb07c94b335072ca4d.svg";